import { BaseTable } from "@/components/shared/data-table";
import { ServerSideDataTablePagination } from "@/components/shared/tables/server-side-table-pagination";
import { ErrorMessage } from "@/components/ui/error";
import { useEffect, useRef } from "react";
import type { BankBookingsTableInstance } from "./use-bank-bookings-table";

export const BankBookingsExportTable = (props: BankBookingsTableInstance) => {
  const tableRef = useRef(null);

  const {
    table,
    clickableColumns,
    columnVisibility,
    columns,
    data,
    stickyColumns,
    footer,
    loading,
    error,
    pagination,
    handleRowClick,
    handlePageChange,
    handlePageSizeChange,
    limit,
  } = props;

  useEffect(() => {
    return () => {
      table.setFocusedRow(undefined);
    };
  }, [table]);

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ErrorMessage message={error.message} />
      </div>
    );
  }

  return (
    <div className="h-full flex flex-row">
      <div
        className="transition-all duration-100 ease-in-out relative flex-1"
        id="transactions-table"
      >
        <div className="flex flex-col gap-2 h-full w-full">
          <BaseTable
            table={table}
            clickableColumns={clickableColumns}
            columnVisibility={columnVisibility}
            columns={columns}
            data={data}
            stickyColumns={stickyColumns}
            footer={footer}
            loading={loading}
            ref={tableRef}
            onRowClick={handleRowClick}
            getSubRowStyle={(row) => row.depth > 0 && "bg-slate-50"}
            rowClassName="h-[42px] min-h-[42px]"
            estimateSize={42}
          />
          <div className="mt-0.5" />
          <ServerSideDataTablePagination
            table={table}
            totalItems={pagination.totalItems}
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            pageSize={limit}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </div>
  );
};
